import React, { useState } from 'react';
import {Container, Nav, Navbar, Button} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ASSET_URL } from '../../config/config';

const Header = () => {

const[fix, setFix]=useState(false);

function setFixed(){
  if (window.scrollY >= 100){
    setFix(true)
  }else{
    setFix(false)
  }
}

window.addEventListener("scroll", setFixed)

  return (
    <div className='clearfix'>
    <div className='header header-light header-topbar header-topbar1 header-shadow'>
        <Navbar expand="lg" className={fix ? 'navbar-fixed' : 'navbar'}>
            <Container>
                <Navbar.Brand href="#home">
                    <Link id='header_logo' to="/"><img src={ASSET_URL+'assets/images/logo/logo-dark.png'} alt="Logo" className='logo' /></Link>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ms-auto">
                    <Nav.Link as={Link} to="/">Home</Nav.Link>
                    <Nav.Link as={Link} to="/aboutus">About Us</Nav.Link>
                    <Nav.Link as={Link} to="/solutions">Solutions</Nav.Link>
                    <Nav.Link as={Link} to="/blog">Blog</Nav.Link>
                    <Nav.Link as={Link} to="/media">Media</Nav.Link>
                    <Nav.Link as={Link} to="/contactus">Contact Us</Nav.Link>
                    <Nav.Link as={Link} to="/testride"><Button className="btn btn-danger">Test Ride</Button></Nav.Link>
                </Nav> 
                </Navbar.Collapse>
            </Container>
        </Navbar>
    </div>
    </div>
  )
}

export default Header